import React from 'react';

import { fetchCategoryUiConfig } from 'app/actions/BrowseActions';
import { performCatalogSearch } from 'app/actions/SearchActions';
import BrowseCategoryPage from 'app/components/browse/category';
import { BROWSE_CATEGORY_PAGE_FACET_FIELD_IDS, FILTERABLE_DISPLAY_BIB_GRID_LIMIT } from 'app/constants/BrowseConstants';
import { mapQuerySearchParamsToCatalogSearchFilters } from 'app/helpers/browse';
import connectRoute from 'app/routes/connectRoute';

const BrowseCategoryPageRoute = () => <BrowseCategoryPage />;

const createPerformCatalogSearchForCategoryAction = search => {
  return state => {
    const isLeaf = state.getIn(['browse', 'categoryPage', 'isLeaf']);
    const searchQueryParams = state.getIn(['browse', 'categoryPage', 'searchQueryParams'])?.toJS();

    if (!isLeaf) {
      return null;
    }

    const baseSearchQuery = {
      ...searchQueryParams,
      limit: FILTERABLE_DISPLAY_BIB_GRID_LIMIT,
      view: 'grouped'
    };

    const filterQueryParams = new URLSearchParams(search);
    const catalogSearchFilters = mapQuerySearchParamsToCatalogSearchFilters(filterQueryParams, {
      fieldIds: BROWSE_CATEGORY_PAGE_FACET_FIELD_IDS
    });

    return performCatalogSearch(
      { ...baseSearchQuery, ...catalogSearchFilters },
      { isPersistShowMoreFiltersFieldId: true }
    );
  };
};

const getRouteData = ({ dispatch, location, params, state }) => {
  const [categoryId] = params ?? [];

  const serializedCategoryId = '/'.concat(categoryId || '').replace(/\/+$/, '');
  const loadedCategoryId = state.getIn(['browse', 'categoryPage', 'category', 'categoryId']);
  if (loadedCategoryId === serializedCategoryId) {
    return [dispatch(createPerformCatalogSearchForCategoryAction(location.search)(state))];
  }

  return [
    dispatch(
      fetchCategoryUiConfig({
        postSuccess: createPerformCatalogSearchForCategoryAction(location.search),
        categoryId: serializedCategoryId
      })
    )
  ];
};

export default connectRoute(BrowseCategoryPageRoute, { getRouteData });
